<template>
  <div>
    <div>
      <el-row>
        <el-col :span="5">
          <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search"
            v-model.trim="condition.phone" @keyup.enter.native="onSearch()"></el-input>
        </el-col>
        <el-col :span="5">
          <el-select placeholder="大学" v-model="condition.groupNumber" @change="onConditionChange" size="medium" filterable
            class="margin-left-20px">
            <el-option v-for="item in universityGroups" :key="item.IdValue" :label="item.NameValue" :value="item.GroupNumber">
            </el-option>
          </el-select>
        </el-col>
        <!-- <el-col :span="4">
          <span class="margin-left-20px" v-if="currentTerm">
            当前学期:{{currentTerm.DisplayLable}}
          </span>
          <el-select placeholder="学期" v-model="condition.termId" @change="onConditionChange" size="medium" class="margin-left-20px">
            <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="14" class="text-right">
          <el-button size="medium" type="primary" @click="onSearch()" :disabled="loading">搜索</el-button>
          <el-button type="primary" class="margin-left-20px" :disabled="loading || isExporting" size="medium" @click="onExport" :loading="isExporting">导出</el-button>
          <el-button type="primary" class="margin-left-20px" :disabled="loading || isExporting" size="medium" @click="onExportRawData" :loading="isExporting">导出原格式</el-button>
        </el-col>
      </el-row>
      <el-row class="margin-top-10">
        <el-col :span="5">
          对比学期:
        </el-col>
        <el-col :span="5">
          <el-select placeholder="上学期" v-model="condition.previousTermId" class="margin-left-20px"
            @change="onPreviousTermChange" size="medium">
            <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select placeholder="上学期报课" :loading="isPreviousTermLoading" v-model="condition.hasPreviousTermCourse" size="medium" @change="onConditionChange" class="margin-left-20px">
            <el-option v-for="item in previousTermOptions" :key="item.value" :label="item.desc" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="margin-top-10">
        <el-col :span="5">
          当前学期:
        </el-col>
        <el-col :span="5"> 
          <el-select placeholder="本学期" v-model="condition.currentTermId" class="margin-left-20px"
            @change="onCurrentTermChange" size="medium">
            <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select placeholder="本学期报课" :loading="isCurrentTermLoading" v-model="condition.hasCurrentTermCourse" size="medium" @change="onConditionChange" class="margin-left-20px">
            <el-option v-for="item in currentTermOptions" :key="item.value" :label="item.desc" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="margin-top-10">
        <el-col :span="5">
          <el-select placeholder="占位" v-model="condition.hasAdvanceEnrollment" size="medium" @change="onConditionChange">
            <el-option :key="0" :value="0" label="忽略是否有占位"></el-option>
            <el-option v-for="item in haveOptions" :key="item.value" :label="item.desc + '占位'" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select placeholder="余额" v-model="condition.hasBalance" size="medium" @change="onConditionChange" class="margin-left-20px">
            <el-option :key="0" :value="0" label="忽略是否有余额"></el-option>
            <el-option v-for="item in haveOptions" :key="item.value" :label="item.desc + '余额'" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select placeholder="会员" v-model="condition.isMember" size="medium" @change="onConditionChange" class="margin-left-20px">
            <el-option :key="0" :value="0" label="忽略是否会员"></el-option>
            <el-option v-for="item in yesNoOptions" :key="item.value" :label="item.desc + '会员'" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select placeholder="新生" v-model="condition.isNew" size="medium" @change="onConditionChange" class="margin-left-20px">
            <el-option :key="0" :value="0" label="忽略是否新生"></el-option>
            <el-option v-for="item in yesNoOptions" :key="item.value" :label="item.desc + '新生'" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <pagination v-loading="loading" :data="listData" :option="paginationOption" @search="search" @loadData="onLoadList"
      @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange">
    </pagination>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import pagination from "../common/pagination";
import { getStudentSearchList, exportStudentSearchList, exportStudentSearchRawData } from "../../service/student.service";
import { downloadFile } from "@/config/mUtils";
import {
  getUniversityGroups,
  getTerms,
} from "../../service/common.service";

export default {
  props: {},
  data() {
    return {
      loading: false,
      isConditionChange: false,
      isExporting: false,
      isPreviousTermLoading: false,
      isCurrentTermLoading: false,
      listData: [],
      pageSize: 20,
      paginationOption: {},
      condition: {
        groupNumber: "",
        previousTermId: "",
        currentTermId: "",
        hasAdvanceEnrollment: 0,
        hasPreviousTermCourse: 0,
        hasCurrentTermCourse: 0,
        hasBalance: 0,
        isMember: 0,
        isNew: 0,
      },
      yesNoOptions: [
        {
          key: "Yes",
          value: 1,
          desc: ""
        },
        {
          key: "No",
          value: 2,
          desc: "非"
        }
      ],
      haveOptions: [
        {
          key: "Yes",
          value: 1,
          desc: "有"
        },
        {
          key: "No",
          value: 2,
          desc: "没有"
        }
      ],
      universityGroups: [
        {
          IdValue: "",
          GroupNumber: "",
          NameValue: "所有学校",
        },
      ],
      termList: [],
      currentTerm: null,
      previousTermOptions:[],
      currentTermOptions:[],
    };
  },
  components: {
    pagination,
  },
  created() {
    this.paginationOption = {
      displayPagination: true,
      hasEditButton: false,
      hasAddButton: false,
      hasSearch: false,
      hasDeleteButton: false,
      buttonWidth: 100
    };

    getUniversityGroups(true, true).then((result) => {
      if (!!result && result.success) {
        this.universityGroups = this.universityGroups.concat(result.data);
      }
    });

    getTerms(false).then((result) => {
      if (!!result && result.success) {
        this.termList = result.data;
        let index = this.termList.findIndex((i) => i.IsCurrentTerm);
        if (index >= 0){
          let currentTerm = this.termList[index];
          if (!!currentTerm) {
            this.currentTerm = currentTerm;
            this.condition.currentTermId = currentTerm.Id;
            if (index + 1 < this.termList.length){
              this.condition.previousTermId = this.termList[index + 1].Id;
            }
            this.previousTermOptions = this.loadTermOptions(this.condition.previousTermId);
            this.currentTermOptions = this.loadTermOptions(this.condition.currentTermId);
          }
        }
      }
    });
  },
  methods: {
    onSearch() {
      if (!this.validate()){
        return;
      }
      this.search();
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.loadListData(pageData);
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    loadListData(pageData) {
      this.loading = true;
      this.isConditionChange = false;
      getStudentSearchList(pageData)
        .then((result) => {
          if (!!result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let additionalFilter = {
        groupNumber: this.condition.groupNumber,
        previousTermId: this.condition.previousTermId,
        currentTermId: this.condition.currentTermId,
        hasAdvanceEnrollment: this.condition.hasAdvanceEnrollment,
        hasPreviousTermCourse: this.condition.hasPreviousTermCourse,
        hasCurrentTermCourse: this.condition.hasCurrentTermCourse,
        hasBalance: this.condition.hasBalance,
        isMember: this.condition.isMember,
        isNew: this.condition.isNew
      };
      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.condition.phone,
        additionalFilter: additionalFilter,
      };

      return pageData;
    },
    onConditionChange(){
      this.isConditionChange = true;
    },
    async onExport(){
      if (!this.validate()){
        return;
      }
      this.isExporting = true;
      try {
        if (this.isConditionChange){
          this.search();
        }
        let pageData = this.getSearchPageData();
        let result = await exportStudentSearchList(pageData);
        if (!!result && result.success) {
          downloadFile(result);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isExporting = false;
      }
    },
    async onExportRawData(){
      if (!this.validate()){
        return;
      }
      this.isExporting = true;
      try {
        if (this.isConditionChange){
          this.search();
        }
        let pageData = this.getSearchPageData();
        let result = await exportStudentSearchRawData(pageData);
        if (!!result && result.success) {
          downloadFile(result);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isExporting = false;
      }
    },
    validate(){
      // if (!this.condition.termId){
      //   this.$message.warning("没有选择学期");
      //   return false;
      // }

      if (!this.condition.phone && !this.condition.groupNumber && !this.condition.hasAdvanceEnrollment && !this.condition.hasPreviousTermCourse && !this.condition.hasCurrentTermCourse
        && !this.condition.hasBalance && !this.condition.isMember && !this.condition.isNew){
        this.$message.warning("没有选择任何筛选条件");
        return false;
      }
      return true;
    },
    loadTermOptions(termId){
      let term = this.termList.find(i => i.Id === termId);
      let termName = term.DisplayLable;
      let list = [ 
        {
          key: "Yes",
          value: 0,
          desc: `忽略${termName}是否报课`
        },
        {
          key: "Yes",
          value: 1,
          desc: `${termName}有报课`
        },
        {
          key: "No",
          value: 2,
          desc: `${termName}没有报课`
        }
      ];
      return list;
    },
    loadPreviousTermOptions(){
      this.isPreviousTermLoading = true;
      let value = this.condition.hasPreviousTermCourse;
      this.previousTermOptions = this.loadTermOptions(this.condition.previousTermId);
      this.condition.hasPreviousTermCourse = "";
      this.condition.hasPreviousTermCourse = value;
      this.isPreviousTermLoading = false;
    },
    loadCurrentTermOptions(){
      this.isCurrentTermLoading = true;
      let value = this.condition.hasCurrentTermCourse;
      this.currentTermOptions = this.loadTermOptions(this.condition.currentTermId);
      this.condition.hasCurrentTermCourse = "";
      this.condition.hasCurrentTermCourse = value;
      this.isCurrentTermLoading = false;
    },
    onPreviousTermChange(){
      this.loadPreviousTermOptions();
    },
    onCurrentTermChange(){
      this.loadCurrentTermOptions();
    },
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/studentList/studentSearchList.vue